<template>
  <div ref="picker" class="picker">
    <div @click="open = !open" class="picker-input">
      {{ pickedLabel }} <chevron-down-icon />
    </div>
    <div v-if="open" class="picker-options">
      <div
        class="picker-options-item"
        @click="pick(option)"
        v-for="option in options"
        :key="option[keyField]"
      >
        {{ option[labelField] }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { ChevronDownIcon } from "@heroicons/vue/24/solid";

@Options({
  components: {
    ChevronDownIcon,
  },
  data() {
    return {
      open: false,
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    keyField: {
      type: String,
      default: "_id",
    },
    labelField: {
      type: String,
      default: "name",
    },
    placeholder: {
      type: String,
      default: "Pick an option",
    },
  },
})
export default class Picker extends Vue {
  // eslint-disable-next-line
  value!: Record<string, any> | null;
  // eslint-disable-next-line
  options!: Record<string, any>[];
  keyField!: string;
  labelField!: string;
  placeholder!: string;
  open!: boolean;

  mounted() {
    window.addEventListener("click", this.handleClickOutside);
  }

  beforeUnmount() {
    window.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(e: MouseEvent) {
    const picker = this.$refs.picker as HTMLElement;
    let node = e.target as HTMLElement | null;
    while (node) {
      if (node === picker) {
        return;
      }
      node = node.parentElement;
    }
    this.open = false;
  }

  get pickedLabel() {
    if (!this.value) return this.placeholder;
    return this.value[this.labelField];
  }

  // eslint-disable-next-line
  pick(option: Record<string, any>) {
    this.$emit("pick", option);
    this.open = false;
  }
}
</script>

<style lang="scss">
.picker {
  position: relative;

  .picker-input {
    cursor: pointer;
    padding: 2px 6px;
    box-sizing: border-box;
    height: 28px;
    width: 100%;
    background-color: white;
    border: 1px solid #999;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      margin-top: 2px;
      margin-left: 2px;
      width: 12px;
    }
  }

  .picker-options {
    position: absolute;
    z-index: 200;
    background: white;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #999;
    top: 30px;
    max-height: 21px * 5;
    overflow: auto;

    .picker-options-item {
      padding: 3px 4px;
      height: 21px;
      cursor: pointer;
      box-sizing: border-box;
      &:hover {
        background: linear-gradient(180deg, #e0e0e0 0%, #c0c0c0 100%);
      }
    }
  }
}
</style>
